

import seoTags from "@/mixins/seoTags";

export default {
	mixins: [seoTags],
	validate(ctx) {
		return ctx.params.category === 'cars' || ctx.params.category === 'new'
	},
	mounted() {
		  window.scrollTo(0, 0); 

		// if(!this.$device.isMobile){
		// 	setTimeout(function () {window.scrollTo(0, 400);}, 2);
		// }
	},
}

